"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterNavTree = void 0;
function pathBlockedByFlags(path, flags) {
    if (!path || !flags)
        return false;
    if (path.startsWith('/llm/maas') && flags.maasEnabled === false)
        return true;
    if (path.startsWith('/llm/bill') && flags.billingEnabled === false)
        return true;
    if (path.startsWith('/llm/train') && flags.trainEnabled === false)
        return true;
    if (path.startsWith('/llm/deploy') && flags.deployEnabled === false)
        return true;
    return false;
}
function nodeBlockedByVisibility(node, ctx, mode) {
    var _a;
    const vis = node.visibility;
    if (!(vis === null || vis === void 0 ? void 0 : vis.length))
        return false;
    if (vis.includes('adminMode') && mode === 'react' && !ctx.isAdminMode)
        return true;
    for (const v of vis) {
        if (v === 'adminMode')
            continue;
        const enabled = (_a = ctx.flags) === null || _a === void 0 ? void 0 : _a[v];
        if (enabled === false)
            return true;
    }
    return false;
}
function nodeVisible(node, ctx, mode) {
    var _a, _b, _c;
    if (nodeBlockedByVisibility(node, ctx, mode))
        return false;
    if (pathBlockedByFlags(node.path, ctx.flags))
        return false;
    if (node.permission && ctx.hasPermission && !ctx.hasPermission(node.permission))
        return false;
    if (node.adminOnly && !ctx.isSuperAdmin)
        return false;
    if (node.adminRoleOnly) {
        const ok = (_b = (_a = ctx.hasAnyRole) === null || _a === void 0 ? void 0 : _a.call(ctx, ['admin'])) !== null && _b !== void 0 ? _b : true;
        if (!ok)
            return false;
    }
    if (((_c = node.roles) === null || _c === void 0 ? void 0 : _c.length) && ctx.hasAnyRole && !ctx.hasAnyRole(node.roles))
        return false;
    return true;
}
function filterChildren(children, ctx, mode) {
    if (!(children === null || children === void 0 ? void 0 : children.length))
        return children;
    const out = [];
    for (const c of children) {
        const f = filterNavTreeNode(c, ctx, mode);
        if (f)
            out.push(f);
    }
    return out.length ? out : undefined;
}
function filterNavTreeNode(node, ctx, mode) {
    var _a;
    if (!nodeVisible(node, ctx, mode))
        return null;
    const children = filterChildren(node.children, ctx, mode);
    const isGroup = node.type === 'group' || !!(node.children && node.children.length);
    if (isGroup && (!children || children.length === 0))
        return null;
    if (children === null || children === void 0 ? void 0 : children.length)
        return Object.assign({}, node, { children });
    if (((_a = node.children) === null || _a === void 0 ? void 0 : _a.length) && !(children === null || children === void 0 ? void 0 : children.length))
        return null;
    return Object.assign({}, node);
}
/**
 * Returns a deep-filtered copy. Empty groups are removed.
 * - mode `react`: drops `visibility: adminMode` nodes when `!isAdminMode`.
 * - mode `vue`: keeps those nodes (caller should attach `hidden` via toVueSidebarMenus).
 */
function filterNavTree(nodes, ctx, mode = 'react') {
    const out = [];
    for (const n of nodes) {
        const f = filterNavTreeNode(n, ctx, mode);
        if (f)
            out.push(f);
    }
    return out;
}
exports.filterNavTree = filterNavTree;
